import React, { useMemo } from 'react';
import { Box, Avatar, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const ProfilePhoto = ({ firstName, lastName }) => {
  const initials = useMemo(() => {
    if (firstName && lastName) {
      return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }
    return 'OP';
  }, [firstName, lastName]);

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      mb: 0
    }}>
      <Box sx={{ position: 'relative' }}>
        <Avatar
          alt="Avatar"
          variant="circular"
          sx={{
            width: 32,
            height: 32,
            backgroundColor: '#BDBDBD',
            color: 'white',
            fontSize: '16px',
            fontWeight: 'bold',
            borderRadius: '100px'
          }}
        >
          {initials}
        </Avatar>
      </Box>
    </Box>
  );
};

export default ProfilePhoto;
